export function getCsrfToken(): string | null {
  const meta = document.querySelector('meta[name="csrf-token"]')
  return meta ? meta.getAttribute('content') : null
}

export function fetchWithCsrf(url: string, options: RequestInit = {}): Promise<Response> {
  const token = getCsrfToken()
  const headers = new Headers(options.headers || {})

  if (token && !headers.has('X-CSRF-Token')) {
    headers.set('X-CSRF-Token', token)
  }

  return fetch(url, {
    ...options,
    headers,
  })
}
